<template>
  <div class="pa-0">
    <v-navigation-drawer
      color="primary"
      v-model="drawer"
      app
      dark
      :right="$i18n.locale == 'ar'"
    >
      <v-list>
        <v-list-item>
          <v-list-item-action>
            <div
              style="background-color: white; border-radius: 100%; padding: 5px"
            >
              <v-img
                width="50px"
                height="50px"
                src="../../assets/tafee icon.svg"
              ></v-img>
            </div>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title style="font-size: 15px">{{
              $t("taafi Dashboard")
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <custom-list-item
          :item="item"
          v-for="(item, index) in items"
          :key="index"
          @activate="activateItem"
          @logout="logout"
        ></custom-list-item>
      </v-list>
      <template v-slot:append>
        <v-list-item @click="logout" class="d-flex">
          <v-list-item-icon>
            <v-icon color="white">mdi-logout</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t("logout") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-navigation-drawer>

    <v-app-bar app color="primary">
      <v-btn class="mx-4" icon @click.stop="drawer = !drawer">
        <v-icon class="mx-4" color="white">mdi-menu</v-icon>
      </v-btn>
      <v-icon @click="changeLang" color="white">mdi-earth</v-icon>
      <!-- App bar content goes here -->
    </v-app-bar>
  </div>
</template>

<script>
import CustomListItem from "./drawerItem.vue";
import { Auth } from "@/store/auth";

export default {
  components: {
    CustomListItem,
  },
  data() {
    return {
      drawer: true,
      items: [
        { title: "home", icon: "mdi-home", route: "/home" },
        {
          title: "cards",
          icon: "mdi-cards",
          route: "/more/cards",
        },

        {
          title: "categories",
          icon: "mdi-folder-open",
          route: "/more/categories",
        },
        {
          title: "countries",
          icon: "mdi-map-marker-radius",
          route: "/countries",
        },

        {
          title: "cities",
          icon: "mdi-city-variant-outline",
          route: "/more/cities",
        },
        {
          title: "users",
          icon: "mdi-account-multiple",
          route: "/more/users",
        },
        {
          title: "company insurance",
          icon: "mdi-office-building-cog",
          route: "/insurance",
        },
      ],
      activeItem: null,
    };
  },
  methods: {
    activateItem(item) {
      this.activeItem = item;
    },
    logout() {
      Auth.logout();
    },

    changeLang() {
      if (this.$i18n.locale == "en") {
        this.$i18n.locale = "ar";
        this.$vuetify.rtl = true;
      } else if (this.$i18n.locale == "ar") {
        this.$i18n.locale = "en";
        this.$vuetify.rtl = false;
      }
    },
  },
};
</script>
